import { Directive, Injector, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { ActionService, ColumnConfig, SessionService } from '@aurora';
import { filter, Subject, takeUntil } from 'rxjs';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, InteractionStatus } from '@azure/msal-browser';

@Directive()
export class ViewBaseComponent implements OnDestroy {
    actionService: ActionService; // service to control application flow
    sessionService: SessionService;
    router: Router; // instance current router object
    unsubscribeAll$: Subject<void> = new Subject(); // subject to destroy all subscriptions in ngOnDestroy life cycle
    activatedRoute: ActivatedRoute; // instance current activated router object

    // UI
    snackBar: MatSnackBar; // snack bar common to all components
    confirmationService: FuseConfirmationService; // confirmation service to show dialogs
    translocoService: TranslocoService; // translation service
    currentActionId: string; // store current action id
    columnsConfig: ColumnConfig[]; // columns data config
    authService: MsalService;
    msalBroadcastService: MsalBroadcastService;
    activeAccount: AccountInfo;
    private readonly _destroying$ = new Subject<void>();

    constructor(protected injector: Injector) {
        this.actionService = this.injector.get(ActionService);
        this.sessionService = this.injector.get(SessionService);
        this.router = this.injector.get(Router);
        this.actionService = this.injector.get(ActionService);
        this.sessionService = this.injector.get(SessionService);
        this.router = this.injector.get(Router);
        this.activatedRoute = this.injector.get(ActivatedRoute);

        // UI
        this.snackBar = this.injector.get(MatSnackBar);
        this.confirmationService = this.injector.get(FuseConfirmationService);
        this.translocoService = this.injector.get(TranslocoService);
        this.authService = this.injector.get(MsalService);
        this.msalBroadcastService = this.injector.get(MsalBroadcastService);

        this.checkAndSetActiveAccount();
    }
    checkAndSetActiveAccount(): void {
        /**
         * If no active account set but there are accounts signed in, sets first account to active account
         * To use active account set here, subscribe to inProgress$ first in your component
         * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
         */
        this.activeAccount = this.activeAccount = this.authService.instance.getAllAccounts()[0];


        if (
            !this.activeAccount &&
            this.authService.instance.getAllAccounts().length > 0
        ) {
            const accounts = this.authService.instance.getAllAccounts();
            this.authService.instance.setActiveAccount(accounts[0]);
        }
    }
    ngOnDestroy(): void {
        this.unsubscribeAll$.next();
        this.unsubscribeAll$.complete();
    }
}
